const supplementaryInformationJSON = {
  section: 'SUPI',
  topic: 'Supplementary Information',
  checked: 'true',
  // access: "public",
  color: 'secondary',
  description: '',
  body: [
    {
      id: 'SUPI.1',
      shortname: 'supi3',
      mandatory: 'true',
      name: 'What is your preferred name?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SUPI3',
      depending: '',
      exception: '',
    },
    {
      id: 'SUPI.1.1',
      shortname: 'supi1-1-vir',
      mandatory: 'true',
      name: 'Add Representative Info?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Yes', 'No'],
      act: 'SUPI1-1-VIR',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'SUPI.2',
      shortname: 'supi2-subtopic',
      name: 'Representative Info:',
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'subtopic',
      act: 'SUPI2-SUBTOPIC',
      depending: 'SUPI1-1-VIR',
      exception: 'Yes',
    },
    {
      id: 'SUPI.2.1',
      shortname: 'supi2-1',
      mandatory: 'true',
      name: '',
      prevalue: 'Authorized Representative:',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'SUPI2-1',
      depending: 'SUPI1-1-VIR',
      exception: 'Yes',
      subtopic_container_act: 'SUPI2-SUBTOPIC',
      suptopic_code: 'SUPI2-REPRESENTATIVE-NAME',
    },
    {
      id: 'SUPI.2.2',
      // extend: "true",
      shortname: 'supi2-2',
      mandatory: 'true',
      name: '',
      prevalue: "Authorized Representative's Phone Number:",
      value: '',
      disabled: 'false',
      type: 'phone',
      act: 'SUPI2-2',
      depending: 'SUPI1-1-VIR',
      exception: 'Yes',
      subtopic_container_act: 'SUPI2-SUBTOPIC',
      suptopic_code: 'SUPI2-REPRESENTATIVE-PHONE',
    },
    {
      id: 'SUPI.3.1',
      shortname: 'supi3-1-vir',
      mandatory: 'true',
      name: `Add Payee's Info:`,
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Yes', 'No'],
      act: 'SUPI3-1-VIR',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'SUP3.1',
      shortname: 'supi0-subtopic',
      name: "Payee's Info:",
      prevalue: '',
      value: '',
      disabled: 'true',
      type: 'subtopic',
      act: 'SUPI1-SUBTOPIC',
      depending: 'SUPI3-1-VIR',
      exception: 'Yes',
    },
    {
      id: 'SUPI.3.1',
      shortname: 'supi1-1',
      mandatory: 'true',
      name: '',
      prevalue: 'Authorized Payee Name:',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'SUPI1-1',
      depending: 'SUPI3-1-VIR',
      exception: 'Yes',
      subtopic_container_act: 'SUPI1-SUBTOPIC',
      suptopic_code: 'SUPI1-PAYEE-NAME',
    },
    {
      id: 'SUPI.3.2',
      // extend: "true",
      shortname: 'supi1-2',
      mandatory: 'true',
      name: '',
      prevalue: "Authorized Payee's phone number:",
      value: '',
      disabled: 'true',
      type: 'phone',
      act: 'SUPI1-2',
      depending: 'SUPI3-1-VIR',
      exception: 'Yes',
      subtopic_container_act: 'SUPI1-SUBTOPIC',
      suptopic_code: 'SUPI1-PAYEE-PHONE',
    },

    {
      id: 'SUPI.4',
      shortname: 'supi5',
      mandatory: 'true',
      name: 'How do you identify your gender?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Male', 'Female', 'Non Binary'],
      act: 'SUPI5',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'SUPI.5',
      shortname: 'supi6',
      mandatory: 'true',
      name: 'Do you need an interpreter?',
      prevalue: '',
      value: 'No',
      disabled: 'false',
      type: 'radio',
      radio_options: ['Yes', 'No', 'N/A'],
      act: 'SUPI6',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'SUPI.6',
      shortname: 'supi7',
      mandatory: 'true',
      name: 'What is your primary language?',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'select',
      ruletype: 'string',
      select_options: [
        '',
        'English',
        'Spanish',
        'Chinese',
        'French',
        'Russian',
        'German',
        'Vietnamese',
        'Portuguese',
        'Farsi',
        'Arabic',
        'Other',
      ],
      act: 'SUPI7',
      mandatory: 'true',
      depending: '',
      exception: '',
      link: 'SUPI7-1',
    },
    {
      id: 'SUPI.6.1',
      extend: 'true',
      // mandatory: 'true',
      shortname: 'supi7-1',
      name: '',
      prevalue: 'If other, explain?:',
      value: '',
      disabled: 'true',
      type: 'text',
      act: 'SUPI7-1',
      depending: 'SUPI7',
      exception: 'Other',
    },
  ],
};

export default supplementaryInformationJSON;
